export declare namespace AppSplashCardTokenSections {
	interface Card {
		shadow: string;
	}

	interface Header {
		background: string;
		padding: string;
	}

	interface Display {
		color: string;
		fontSize: string;
		fontWeight: string;
		letterSpacing: string;
		lineHeight: string;
	}

	interface Title {
		color: string;
		fontSize: string;
		fontWeight: string;
		lineHeight: string;
	}

	interface Message {
		color: string;
		fontSize: string;
		lineHeight: string;
	}
}

export type AppSplashCardTokens = {
	card: AppSplashCardTokenSections.Card;
	header: AppSplashCardTokenSections.Header;
	display: AppSplashCardTokenSections.Display;
	title: AppSplashCardTokenSections.Title;
	message: AppSplashCardTokenSections.Message;
};

export const card: AppSplashCardTokenSections.Card = {
	shadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
};

export const header: AppSplashCardTokenSections.Header = {
	background: '{appHeader.background}',
	padding: '1.5rem 2rem',
};

export const display: AppSplashCardTokenSections.Display = {
	color: '{primary.color}',
	fontSize: '6rem',
	fontWeight: '800',
	letterSpacing: '-0.05em',
	lineHeight: '1',
};

export const title: AppSplashCardTokenSections.Title = {
	color: '{text.color}',
	fontSize: '1.75rem',
	fontWeight: '600',
	lineHeight: '2.25rem',
};

export const message: AppSplashCardTokenSections.Message = {
	color: '{text.muted.color}',
	fontSize: '1rem',
	lineHeight: '1.625rem',
};

export default {
	card,
	header,
	display,
	title,
	message,
} satisfies AppSplashCardTokens;
